/**
 * Role-based access for menus and pages.
 *
 * `access` comes from the server (redux state.common.access):
 *   { loaded, isSuperAdmin, permissions: [{ module, permission }] }
 * Permission levels:
 *   1 View, 2 View|Add, 3 View|Edit, 4 View|Edit|Add, 5 View|Edit|Add|Delete
 * The backend checks the same rules on every API call.
 */
const LEVEL_RIGHTS = {
    1: { List: true, Add: false, Edit: false, Delete: false },
    2: { List: true, Add: true, Edit: false, Delete: false },
    3: { List: true, Add: false, Edit: true, Delete: false },
    4: { List: true, Add: true, Edit: true, Delete: false },
    5: { List: true, Add: true, Edit: true, Delete: true },
};
const NO_RIGHTS = { List: false, Add: false, Edit: false, Delete: false };
const ALL_RIGHTS = LEVEL_RIGHTS[5];

// Older screen names that are managed under one module on the permissions page
const MODULE_ALIASES = {
    Users: "Users Management",
    Roles: "Users Management",
};

export const moduleKey = (module) => MODULE_ALIASES[module] || module;

export default function PermissionAccess(module, access) {
    if (access?.isSuperAdmin) return { ...ALL_RIGHTS };
    const entry = access?.permissions?.find((p) => p?.module === moduleKey(module));
    return { ...(LEVEL_RIGHTS[Number(entry?.permission)] || NO_RIGHTS) };
}

// True when the user has `right` on any of the modules
export function hasAccess(access, modules, right = "List") {
    const list = Array.isArray(modules) ? modules : [modules];
    return list.some((module) => PermissionAccess(module, access)[right]);
}

// First page this user may open (used for "/")
export function homePath(access) {
    if (hasAccess(access, "HIP Dashboard")) return "/hip-dashboard";
    if (hasAccess(access, "HIU Dashboard")) return "/hiu-dashboard";
    if (hasAccess(access, "Users Management")) return "/users";
    return "/organizations";
}
